<div class="dialog-shell">
    <div class="dialog-topbar">
        <button mat-icon-button mat-dialog-close class="button-close--outlined dialog-close" color="primary" aria-label="Chiudi">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-head">
        <mat-icon svgIcon="icon_logo" class="logo-ens"></mat-icon>
        <h2 class="dialog-title">Accedi</h2>
        <p class="dialog-subtitle">Entra per richiedere un interprete o consultare i tuoi appuntamenti.</p>
    </div>

    <form (ngSubmit)="onYesClick()" [formGroup]="formGroup" class="dialog-form">
        <mat-form-field class="fo-field">
            <mat-label>Username</mat-label>
            <input matInput type="text" formControlName="username" autocomplete="username" required />
            <mat-icon matSuffix>perm_identity</mat-icon>
            <mat-error class="error-message" *ngIf="formGroup.controls['username'].hasError('required')"
                >Lo username è obbligatoria</mat-error
            >
        </mat-form-field>

        <mat-form-field class="fo-field">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" autocomplete="current-password" required />
            <mat-icon matSuffix>vpn_key</mat-icon>
            <mat-error class="error-message" *ngIf="formGroup.controls['password'].hasError('required')"
                >La password è obbligatoria</mat-error
            >
        </mat-form-field>

        <button type="submit" class="fo-btn fo-btn--primary fo-btn--block dialog-submit" [disabled]="!formGroup.valid">
            Login
        </button>

        <div class="dialog-links">
            <a (click)="Forgot()" class="forgot dialog-link" tabindex="0">Hai dimenticato la password?</a>
            <p class="dialog-signup">
                Non hai un account?
                <a (click)="Registration()" class="dialog-link" tabindex="0">Registrati</a>
            </p>
        </div>
    </form>
</div>
